module.exports = __webpack_public_path__ + "static/media/storePurchase_75_100.5ed12819.png";